import { NextPage } from 'next'
import Head from 'next/head'
import { useTranslation } from 'react-i18next'
import Header from '~/components/Header'
import Footer from '~/components/Footer'
import { useBreakpoint } from '~/hooks'
import React from 'react'
import { ASSET_PREFIX } from '~/constants/env'
import {
  StyledBrand,
  StyledBrandAssetItem,
  StyledBrandAssets,
  StyledBrandBanner,
} from './styled'

const Brand: NextPage = () => {
  const { t } = useTranslation()
  const { isMobile } = useBreakpoint()
  return (
    <>
      <Head>
        <title>{t('meta_common_title')}</title>
        <meta name="description" content={t('meta_common_description')} />
        <meta name="keywords" content={t('meta_common_keywords')} />
      </Head>
      <Header />
      <StyledBrand>
        <StyledBrandBanner>
          <img
            src={`${ASSET_PREFIX}/images/brand/top${
              isMobile ? '-mobile.png' : '.svg'
            }`}
            alt="brand banner"
          />

          <p>{t('brand_banner_title')}</p>

          <a
            className="button"
            href={ASSET_PREFIX + '/files/Tokenlon_brand_all.zip'}
          >
            {t('download_all')}
          </a>
        </StyledBrandBanner>

        <StyledBrandAssets>
          <StyledBrandAssetItem>
            <div className="with-logo" style={{ background: '#3D3471' }}>
              <img
                src={`${ASSET_PREFIX}/images/brand/tokenlon${
                  isMobile ? '-landscape' : ''
                }.svg`}
                alt="tokenlon"
              />
            </div>
            <div className="with-content" style={{ background: '#5F55A9' }}>
              <p className="title">Tokenlon</p>
              <p className="subtitle">{t('tokenlon_asset_subtitle')}</p>
              <a href={ASSET_PREFIX + '/files/Tokenlon_brand.zip'}>
                {t('download')}
              </a>
            </div>
          </StyledBrandAssetItem>

          <StyledBrandAssetItem>
            <div className="with-content" style={{ background: '#5A4FBB' }}>
              <p className="title">LON</p>
              <p className="subtitle">{t('lon_asset_subtitle')}</p>
              <a href={ASSET_PREFIX + '/files/Tokenlon_brand_LON.zip'}>
                {t('download')}
              </a>
            </div>
            <div className="with-logo" style={{ background: '#8074F1' }}>
              <img src={ASSET_PREFIX + '/images/brand/lon.svg'} alt="lon" />
            </div>
          </StyledBrandAssetItem>
        </StyledBrandAssets>
      </StyledBrand>
      <Footer />
    </>
  )
}

export default Brand
